import React from "react";

import Cookies from "js-cookie";

import { SetPropSeparate } from "react-lib/frameworks/SetProp";
import LocalizationWrapper from "react-lib/localization/LocalizationWrapper";

import AppToday from "react-lib/apps/CheckIn/AppToday";
import AppTodayAppointment from "react-lib/apps/CheckIn/AppTodayAppointment";
import GreetingsMonitor from "react-lib/apps/CheckIn/GreetingsMonitor";
import NoAppNoPKFound from "react-lib/apps/CheckIn/NoAppNoPKFound";
import NoAppPKList from "react-lib/apps/CheckIn/NoAppPKList";
import PatientNotFound from "react-lib/apps/CheckIn/PatientNotFound";
import SearchingMonitor from "react-lib/apps/CheckIn/SearchingMonitor";
import MeHeyLanding from "react-lib/apps/HISV3/common/MeHeyLanding";

import MainCheckInController from "./MainCheckInController";
import * as MainCheckInI from "./MainCheckInInterface";

import "semantic-ui-offline/semantic.min.css";
import "assets/fonts.css";

export class MainCheckIn extends React.Component<MainCheckInI.Props, MainCheckInI.State> {
  controller: MainCheckInController;

  constructor(props: MainCheckInI.Props) {
    super(props);

    this.state = {
      currentPage: "greetings",
    };

    this.controller = new MainCheckInController(
      () => this.state,
      (state, callback) => {
        this.setState(state as any, callback);
      },
      window,
    );

    this.controller.apiToken = Cookies.get("apiToken") || "";
    this.controller.data.division = parseInt(Cookies.get("division_id") || "0");
    this.controller.setProp = SetPropSeparate(this, "");
  }

  componentDidMount() {
    this.runSequence({ sequence: "AppInitialize" });
  }

  runSequence = (params: any) => {
    this.controller.handleEvent({ message: "RunSequence", params });
  };

  handleSocialLoginSuccess = (params: any) => {
    const response = params.pentaToken || params;

    if (!response) return;

    this.controller.handleEvent({
      message: "HandleLoginSuccess",
      params: {
        login: response,
        verify: params.verify,
        onSuccess: () => {
          globalThis.history.pushState(null, "", "/?app=CheckIn");
        },
      },
    });
  };

  render() {
    // No apiToken → show login
    if (this.controller.apiToken === "") {
      return (
        <MeHeyLanding
          setProp={this.controller.setProp}
          controller={this.controller}
          AppInitializeSequence={this.state.AppInitializeSequence}
          loadingLogin={this.state.loadingLogin}
          onLoginSuccess={this.handleSocialLoginSuccess}
          onLoginSubmit={() =>
            this.runSequence({
              sequence: "AppInitialize",
              action: "LoginSubmit",
              onSuccess: () => {
                this.controller.apiToken = Cookies.get("apiToken") || "";
                this.forceUpdate();
              },
              type: "email",
            })
          }
          selectedLanguage="th"
          languageUX="th"
        />
      );
    }

    // Logged in → show CheckIn pages
    switch (this.state.currentPage) {
      case "searching":
        return <SearchingMonitor />;
      case "patientNotFound":
        return <PatientNotFound />;
      case "noAppNoPKFound":
        return <NoAppNoPKFound />;
      case "noAppPKList":
        return <NoAppPKList />;
      case "appTodayAppointment":
        return <AppTodayAppointment />;
      case "appToday":
        return (
          <AppToday
            onEvent={this.controller.handleEvent}
            patientData={this.state.patientData}
            patientCurrentEncounter={this.state.patientCurrentEncounter}
          />
        );
      case "greetings":
      default:
        return (
          <GreetingsMonitor
            onQrScanned={(data) =>
              this.controller.handleEvent({ message: "ScanQR", params: { data } })
            }
          />
        );
    }
  }
}

export default LocalizationWrapper(MainCheckIn);
